var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationArrowDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89 7.76001L9.51437 12.1763C9.56143 12.2076 9.61611 12.2255 9.67257 12.2282C9.72903 12.2309 9.78517 12.2183 9.835 12.1916C9.88483 12.1649 9.9265 12.1252 9.95555 12.0767C9.98461 12.0282 9.99997 11.9728 10 11.9163V3.08376C9.99997 3.02724 9.98461 2.97178 9.95555 2.92329C9.9265 2.8748 9.88483 2.8351 9.835 2.80842C9.78517 2.78174 9.72903 2.76908 9.67257 2.77178C9.61611 2.77448 9.56143 2.79245 9.51437 2.82376L2.89 7.24001C2.8472 7.26855 2.81211 7.30721 2.78784 7.35257C2.76357 7.39792 2.75087 7.44857 2.75087 7.50001C2.75087 7.55145 2.76357 7.6021 2.78784 7.64745C2.81211 7.69281 2.8472 7.73147 2.89 7.76001Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrowDisabled);
export default __webpack_public_path__ + "static/media/paginationArrowDisabled.b78eb07c146211e9ea8fc03ba5c9f0d8.svg";
export { ForwardRef as ReactComponent };